export default "__VITE_ASSET__ZNjKEeS5__"